import {Module} from "vuex";

import {RootStateType} from "@/store";

import actions from "./actions";
import mutations from "./mutations";
import {EventProfileState} from "./model";

let state: EventProfileState = {
  eventProfiles: []
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
} as Module<EventProfileState, RootStateType>;
